import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Card, Input, Spin, Typography, message } from 'antd';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import './ndoeTokens.css';

const { Title, Paragraph } = Typography;
const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
const isYmd = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v || '');

const ParametresAdmin = () => {
  const role = useSelector((s) => s.user?.currentUser?.role);
  const token = useSelector((s) => s.user?.currentUser?.accessToken || s.user?.currentUser?.token);
  const headers = useMemo(() => (token ? { authorization: `Bearer ${token}`, token: `Bearer ${token}` } : {}), [token]);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dateBascule, setDateBascule] = useState('');

  useEffect(() => {
    if (role !== 'admin') { setLoading(false); return; }
    (async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/parametre/date-bascule`, { headers });
        setDateBascule(data.date_bascule || '');
      } catch (e) {
        message.error('Chargement du paramètre impossible.');
      } finally {
        setLoading(false);
      }
    })();
  }, [role, headers]);

  const save = async () => {
    if (!isYmd(dateBascule)) return message.warning('Format attendu : AAAA-MM-JJ.');
    setSaving(true);
    try {
      await axios.put(`${DOMAIN}/api/parametre/date-bascule`, { date_bascule: dateBascule }, { headers });
      message.success('Date de bascule enregistrée.');
    } catch (e) {
      message.error(e?.response?.data?.error || 'Enregistrement échoué.');
    } finally {
      setSaving(false);
    }
  };

  if (role !== 'admin') {
    return <div style={{ padding: 24 }}><Alert type="warning" showIcon message="Accès administrateur requis" /></div>;
  }
  if (loading) return <div style={{ padding: 32, textAlign: 'center' }}><Spin size="large" /></div>;

  return (
    <div style={{ padding: 20, maxWidth: 720, margin: '0 auto' }}>
      <Title level={3} style={{ color: 'var(--ndoe-ink)' }}>Paramètres</Title>
      <Card title="Date de bascule du module de livraison" style={{ borderRadius: 'var(--ndoe-radius-sub, 14px)' }}>
        <Paragraph type="secondary">
          Les livraisons créées <b>avant</b> cette date sont considérées comme héritées (ancien parcours) :
          elles ne réservent plus de stock et n’apparaissent pas dans le hub livreur. Le nouveau module
          prend en charge tout ce qui est créé à partir de cette date.
        </Paragraph>
        <Input
          value={dateBascule}
          onChange={(e) => setDateBascule(e.target.value)}
          placeholder="AAAA-MM-JJ"
          style={{ maxWidth: 220 }}
        />
        <div>
          <Button type="primary" loading={saving} onClick={save} style={{ marginTop: 16, background: 'var(--ndoe-ink)', borderColor: 'var(--ndoe-ink)' }}>
            Enregistrer
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ParametresAdmin;
